import types from './mutation-types';
import { MutationTree } from 'vuex';
import { GlobalStateShape } from 'store';

export default {
	[types.TOGGLE_SIDEBAR_VISIBILITY](state) {
		state.isMobileVisible = !state.isMobileVisible;
	}
} as MutationTree<GlobalStateShape>;
